// DataTable.Cell.Vehicle.vue
<template>
    <!-- <GripLink 
        :to="`/super-admin/vehicle/${props.model.make}`"
        class="flex items-center gap-2 h-full w-full"
        @click.native.prevent="customCellClickEvent"
        ref="cell"
    /> -->
    <p>
        {{ props.model.make }} {{ props.model.model }} ({{ props.model.year }})
    </p>
    <!-- <div>
        <button >Test Button</button>
        <div ref="cell" @click="customCellClickEvent">{{ rowIndex }}</div>
    </div> -->
</template>

<script lang="ts" setup>
import GripLink from '@/components/GripLink.vue';
import { defineProps, ref, inject } from 'vue';
import type { ColumnDataSchemaModel } from '@revolist/vue3-datagrid';

const props = defineProps<ColumnDataSchemaModel>();
const VehicleCell = ref<HTMLElement>();


const message = inject('sample');
function customCellClickEvent() {
  console.log('Custom cell click > Injected message:', message);
  const event = new CustomEvent('cell-custom-action', {
      bubbles: true,
      detail: { row: props.model },
  });
  VehicleCell.value?.dispatchEvent(event);
}
</script>